import { createContext, useContext, useRef, useState, useEffect } from 'react';

const AudioContext = createContext();

export function AudioProvider({ children }) {
    const audioRef = useRef(new Audio());
    const [canPlay, setCanPlay] = useState(false);

    // Unlock audio on first interaction
    useEffect(() => {
        const enableAudio = () => {
            setCanPlay(true);
            window.removeEventListener('click', enableAudio);
            window.removeEventListener('keydown', enableAudio);
        };

        window.addEventListener('click', enableAudio);
        window.addEventListener('keydown', enableAudio);

        return () => {
            window.removeEventListener('click', enableAudio);
            window.removeEventListener('keydown', enableAudio);
        };
    }, []);

    const play = (src) => {
        if (!canPlay || !src) return;

        src = src.startsWith('http') ? src : `/sounds/${src}`;
        const audio = audioRef.current;

        if (audio.src !== src) {
            audio.pause();
            audio.src = src;
            audio.load();

            audio.oncanplaythrough = () => {
                audio.play().catch(() => { });
                audio.oncanplaythrough = null;
            };
        } else {
            audio.play().catch(() => { });
        }
    };

    const pause = () => {
        audioRef.current.pause();
    };

    return (
        <AudioContext.Provider value={{ play, pause }}>
            {children}
        </AudioContext.Provider>
    );
}

export const useAudio = () => useContext(AudioContext);
